import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import type { DiscountMultiInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DISCOUNT_MULTI_FOR_MULTI_CREATE_MUTATION } from "./schema";

export const useDiscountMultiCreateMutation = () => {
	const navigate = useNavigate();
	const { mutationFunc } = useCustomMutation(DISCOUNT_MULTI_FOR_MULTI_CREATE_MUTATION);
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onCreateDiscountMulti = useCallback(
		async (input: DiscountMultiInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "複合ディスカウントを作成しました",
				});
				navigate(generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.TOP, { hotelID: input.hotelID }));
			}
		},
		[hideLoadingScreenCallback, mutationFunc, navigate, showLoadingScreenCallback],
	);

	return {
		onCreateDiscountMulti,
	};
};
